export const MAX_RETRIES = 3;
export const RETRY_DELAY = 1000;

export const FAILURE_FLAG = '__INTERCOM_FAILED__';
export const INTERCOM_SCRIPT_ID = 'intercom-widget-script';
